import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const orderListState = buildServiceState({
    key: 'orderList',
    requireEmployee: true,
    service: Core.SearchOrders,
    beforeRequest: ({ req }) => {
        const settings = getReactRecoilSettings();
        const defaultRequest = {
            PageConfig: {
                Start: 0,
                Limit: settings.defaultPageSize,
            },
            StartTime: req?.StartTime,
        };
        const newRequest = {
            ...defaultRequest,
            ...req,
        };
        return newRequest;
    },
});
export default orderListState;
//# sourceMappingURL=order-list-state.js.map